export default __webpack_public_path__ + "static/media/mobile-view.6916e942.svg";